<div class="edit-container">
  <h1 class="edit-title">Actualizare Configurare</h1>
  <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
    <div class="edit-field">
      <mat-form-field appearance="fill">
        <mat-label>Denumire</mat-label>
        <input type="text" matInput formControlName="name" />
        <mat-error
          *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="edit-field">
      <mat-form-field appearance="fill">
        <mat-label>Observații</mat-label>
        <input type="text" matInput formControlName="value" />
        <mat-error
          *ngIf="
            !form.controls['value'].valid && form.controls['value'].touched
          "
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
    <div class="edit-action-btns">
      <button
        class="buttons"
        type="button"
        mat-flat-button
        (click)="closeDialog()"
      >
        Close
      </button>
      <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
        Save
      </button>
    </div>
  </form>
  <div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
			<h3 class="mt-2">Vă rugăm așteptați!</h3>
		</div>
	</div>
</div>
